<svelte:options tag="pzemng-cookie" immutable={true}/>

<script>
    import Cookies from 'js-cookie';

    // Inputs
    export let domain = 'pzem.nl';
    let hideWidget = isCookieSet();
    let currentCookieValue = Cookies.get('pzem.cookie');
    let widgetRef;

    // Remove the widget if cookie is already set
    if(isCookieSet()) {
        destroyWidget();
    }

    function reject() {
        Cookies.set(
            'pzem.cookie',
            (undefined !== currentCookieValue ? currentCookieValue + ';' : '' ) + 'consent:false',
            {expires: 365, domain: domain, secure: true, sameSite: 'strict'}
        );
        hideWidget = isCookieSet();
        destroyWidget();
    }

    function accept() {
        Cookies.set(
            'pzem.cookie',
            (undefined !== currentCookieValue ? currentCookieValue + ';' : '' ) + 'consent:true',
            {expires: 365, domain: domain, secure: true, sameSite: 'strict'}
        );
        hideWidget = isCookieSet();
        destroyWidget();
    }

    function isCookieSet() {
        return !!Cookies.get('pzem.cookie');
    }

    function destroyWidget() {
        widgetRef.parentNode.removeChild(widgetRef);
    }
</script>

<div class="cookie"
     class:cookie--hide={true === hideWidget}
     bind:this={widgetRef}
>
    <p class="cookie__text">
        PZEM gebruikt cookies om u beter te kunnen helpen en de website te verbeteren. Gaat u akkoord met de cookies?
        <a href="https://www.pzem.nl/cookies"
           target="_blank"
           aria-label="Bekijk meer informatie over onze cookies"
        >
            Meer info
        </a>
    </p>
    <div class="cookie__footer">
        <button class="button button--tertiary"
                aria-label="Cookies weigeren"
                on:click={reject}
        >
            Nee, weiger cookies
        </button>
        <button class="button"
                aria-label="Cookies accepteren"
                on:click={accept}
        >
            Ja, geen probleem
        </button>
    </div>
</div>

<style>
    @import "@nedbase/pzem-ui/style";

    .cookie {
        position: fixed;
        right: var(--spacing--250);
        bottom: var(--spacing--250);
        display: flex;
        flex-direction: column;
        width: 440px;
        padding: var(--spacing--150);
        background-color: rgb(var(--color-black-rgb));
        color: var(--color-white);
        z-index: 2000000;
    }

    .cookie--hide {
        display: none;
    }

    .cookie__text {
        margin-bottom: var(--spacing--225);
        line-height: var(--line-height--small);
    }

    .cookie__text a {
        color: var(--color-primary);
    }

    .cookie__text a:hover,
    .cookie__text a:focus {
        color: var(--color-secondary);
    }

    .cookie__footer {
        display: flex;
        flex-flow: row nowrap;
    }

    .button {
        display: flex;
        align-items: center;
        padding: var(--spacing--75) var(--spacing);
        margin-left: var(--spacing);
        white-space: nowrap;
        text-decoration: none;
        font-weight: var(--font-weight--semi-bold);
        color: var(--color-secondary--contrast);
        background: var(--color-secondary);
        border: 1px solid var(--color-secondary);
        border-radius: var(--border-radius--large);
        transition: all .2s ease;
        outline: none;
        cursor: pointer;
    }

    .button:focus,
    .button:hover {
        color: var(--color-primary--contrast);
        background: var(--color-primary);
        border-color: var(--color-primary);
    }

    .button--tertiary {
        margin-left: 0;
        font-weight: var(--font-weight--regular);
        background: rgb(var(--color-black-rgb));
        border-color: rgb(var(--color-black-rgb));
    }

    .button--tertiary:focus,
    .button--tertiary:hover {
        color: var(--color-white);
        background: rgb(var(--color-black-rgb));
        border-color: var(--color-primary);
    }

    @media (max-width: 600px) {
        .cookie {
            right: var(--spacing);
            bottom: var(--spacing);
            left: var(--spacing);
            width: auto;
            padding: var(--spacing);
        }

        .cookie__footer {
            display: flex;
            flex-wrap: wrap-reverse;
        }

        .button {
            justify-content: center;
            width: 100%;
            margin: 0 0 var(--spacing--50) 0;
            font-size: var(--font-size--xsmall);
        }

        .button--tertiary {
            margin: 0;
        }
    }
</style>
